// extracted by mini-css-extract-plugin
export default {"pending__title":"PendingPayment_pending__title__giUy0","pending__table":"PendingPayment_pending__table__TsiJ-","pending__table_header":"PendingPayment_pending__table_header__ele-S"};